// <s-hair-diagnosis> — ROOTX concern picker. Tapping a concern shows its tailored result panel; the panel's
// "choose this pack" button checks the matching quantity offer card (target fieldset id in data-supply).
class SHairDiagnosis extends HTMLElement {
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();
    const signal = this.#ac.signal;
    this.addEventListener("click", (event) => {
      const chip = event.target.closest("[data-dx-chip]");
      if (chip) {
        this.#select(chip.dataset.dxChip);
        return;
      }
      const pick = event.target.closest("[data-dx-pack]");
      if (pick) this.#pickPack(pick);
    }, { signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #select(id) {
    for (const chip of this.querySelectorAll("[data-dx-chip]")) {
      chip.setAttribute("aria-pressed", String(chip.dataset.dxChip === id));
    }
    for (const panel of this.querySelectorAll("[data-dx-panel]")) {
      panel.hidden = panel.dataset.dxPanel !== id;
    }
    for (const btn of this.querySelectorAll("[data-dx-pack]")) btn.removeAttribute("data-done");
  }

  #pickPack(button) {
    const supply = document.getElementById(this.dataset.supply || "");
    if (!supply) return;
    const input = supply.querySelector(`input[name="quantity"][value="${button.dataset.dxPack}"]`);
    if (!input) return;
    input.checked = true;
    input.dispatchEvent(new Event("change", { bubbles: true }));
    button.setAttribute("data-done", "");
    supply.scrollIntoView({ behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "center" });
  }
}

if (!customElements.get("s-hair-diagnosis")) customElements.define("s-hair-diagnosis", SHairDiagnosis);
